/**
 * @desc 平台店铺应用表分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.AppAccountResponseDto>
>;
export function request(
  params: API.basics.appAccount.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/appAccount/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
